export default {
    stats: state => state.stats,
    sales: state => state.sales,
    activity: state => state.activity,
    coins: state => state.coins,
  }
  